export default {

  //заполнить данные по адресам
  loadGeoItems(state, data){
    state.orgGeoItems=data;
  },

  //заполнить список типов партнеров
  loadPartnerTypes(state, data){
    state.partnerTypes=data;
  },

  //обновить адрес
  editGeoItem(state, editdata){
    var ind= state.orgGeoItems.findIndex(x=>x.id==editdata.id)
    if(ind!=-1&&ind!=undefined){
      state.orgGeoItems.splice(ind,1,editdata);
    }
  },

  //добавить адрес
  addGeoItem(state, newdata){
    state.orgGeoItems.push(newdata)
  },

  //удалить адрес
  deleteGeoItem(state, Id){
    var ind= state.orgGeoItems.findIndex(x=>x.id==Id)
    if(ind!=-1&&ind!=undefined){
      state.orgGeoItems.splice(ind,1);
    }
  },
}
